module.exports = __webpack_public_path__ + "static/customer-care-5d772ff0e9adf508b651d38a0c3bd870.svg";